import React from 'react'
import bgDefault from 'img/bg-default.jpg'
import { Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const LinkWrapper = styled.div.attrs(() => ({
  className: 'bg-white d-flex justify-content-center m-3'
}))`
  button {
    font-size: 1.7em;
    width: 100%;
  }
`

const DirectLinkRedirect = (props) => {
  const { i18n } = useTranslation()

  return (
    <LinkWrapper>
      <Button color="primary" className="w-100 text-dark rounded shadow">
        <a
          className="text-white text-decoration-none"
          href={props.link_url}
          target="_blank"
          rel="noreferrer noopener"
        >
          <strong>
            <i className="fa fa-hand-pointer me-3"></i>
            {i18n.t('direct_link_redirect.button')}
          </strong>
        </a>
      </Button>
    </LinkWrapper>
  )
}

export default DirectLinkRedirect
